<template>
  <div style="margin: 1px;padding: 0">
    <lay-tab type="brief" v-model="current" tabPosition = "left">
      <lay-tab-item id="1">
        <MeterMonitor/>
        <template #title>
          <span>多功能仪表</span>
        </template>
      </lay-tab-item>
      <lay-tab-item title="传感器" id="2">
        <SensorMonitor/>
      </lay-tab-item>
    </lay-tab>
  </div>
</template>

<script setup>
import { ref} from "vue";
import MeterMonitor from "@/components/MeterMonitor";
import SensorMonitor from "@/components/SensorMonitor";
const current = ref('1')
</script>
